<script setup lang="ts">
import { computed } from 'vue'
import Icon from './Icon.vue'
import ScrollAnimate from './ScrollAnimate.vue'
import { useI18n } from '../composables/useI18n'

interface Feature {
  icon: string
  title: string
  description: string
}

const { t } = useI18n()

const features = computed<Feature[]>(() => t('what.items') as Feature[])
</script>

<template>
  <section id="what" class="py-20 bg-base-100">
    <div class="max-w-6xl mx-auto px-4">
      <ScrollAnimate as="div" class="text-center max-w-3xl mx-auto mb-12">
        <h2 class="text-3xl md:text-4xl font-bold text-base-content">{{ t('what.title') }}</h2>
        <p class="text-lg text-base-content/70 mt-4">
          {{ t('what.subtitle') }}
        </p>
      </ScrollAnimate>

      <div class="grid md:grid-cols-3 gap-6">
        <ScrollAnimate
          v-for="(feature, index) in features"
          :key="feature.title"
          as="div"
          class="card bg-base-200 border border-base-300 hover:border-primary/40 transition-colors"
          :delay="index * 0.1"
        >
          <div class="card-body">
            <div class="w-11 h-11 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-4">
              <Icon :name="feature.icon" iconClass="w-6 h-6" />
            </div>
            <h3 class="card-title text-xl">{{ feature.title }}</h3>
            <p class="text-base-content/70">{{ feature.description }}</p>
          </div>
        </ScrollAnimate>
      </div>
    </div>
  </section>
</template>
